<div class="mt-2">
    <button
        title="Download"
        type="button"
        pButton
        class="p-button-secondary"
        pTooltip="Download"
        icon="pi pi-download"
        (click)="dataTable.exportCSV()"
        style="margin-bottom: 0.5em"
    ></button>
    <p-table stripedRows #dataTable
        [value]="items"
        [columns]="cols"
        exportFilename="InvoiceRegister"
        (onFilter)="onFilter($event)"
        responsiveLayout="scroll"
        [scrollable]="true"
        scrollHeight="65vh"
    >
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="numCols" style="text-align: center">
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
            <tr>
                <td [attr.colspan]="numCols" style="text-align: center">
                    <div>
                        Loading...<i class="fa fa-spinner fa-spin"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #header let-columns>
            <tr>
                <!--  InvoiceStart -->
                <th>
                    Start
                </th>
                <!-- InvoiceEnd -->
                <th>
                    End
                </th>
                <!-- Contract -->
                <th>
                    Contract/CN
                </th>
                <!-- Invoice Number -->
                <th>
                    Invoice Number
                </th>
                <!-- Cost/Calc Type -->
                <th>
                    Cost/Calc Type
                </th>
                <!-- Hours -->
                <th>
                    Hours
                </th>
                <!-- Unloaded Amt -->
                <th>
                    Unloaded Amt
                </th>
                <!-- Loaded Amt -->
                <th>
                    Loaded Amt
                </th>
                <!-- Fee -->
                <th>
                    Fee
                </th>
                <!-- Total Amt -->
                <th>
                    Total Amt
                </th>
            </tr>
        </ng-template>
        <ng-template
            #body
            let-item
            let-columns="columns"
            let-rowIndex="rowIndex"
        >
            <tr>
                <td
                    [title]="item.InvoiceStart"
                    *ngIf="
                        rowGroupMetadata[item.groupIndex]?.index ===
                        rowIndex
                    "
                    [attr.rowspan]="
                        rowGroupMetadata[item.groupIndex]?.size + 1
                    "
                >
                    {{ moment(item.InvoiceStart).format('L') }}
                </td>
                <td

                    [title]="item.InvoiceEnd"
                    *ngIf="
                        rowGroupMetadata[item.groupIndex]?.index ===
                        rowIndex
                    "
                    [attr.rowspan]="
                        rowGroupMetadata[item.groupIndex]?.size + 1
                    "
                >
                    {{ moment(item.InvoiceEnd).format('L') }}
                </td>
                <td

                    [title]="item.FullName"
                    *ngIf="
                        rowGroupMetadata[item.groupIndex]?.index ===
                        rowIndex
                    "
                    [attr.rowspan]="
                        rowGroupMetadata[item.groupIndex]?.size + 1
                    "
                >
                    {{ item.FullName }}
                </td>
                <td

                    [title]="item.InvoiceNbr"
                    *ngIf="
                        rowGroupMetadata[item.groupIndex]?.index ===
                        rowIndex
                    "
                    [attr.rowspan]="
                        rowGroupMetadata[item.groupIndex]?.size + 1
                    "
                >
                    {{ item.InvoiceNbr }}
                </td>
                <td

                    [title]="item.CalcType"
                >
                    {{ item.CalcType }}
                </td>
                <td

                    [title]="item.ActualHours"
                >
                    {{ item.ActualHours }}
                </td>
                <td
                    class="currency"
                    [title]="item.InvoiceAmount"
                >
                    {{ item.InvoiceAmount | currency }}
                </td>
                <td
                    class="currency"
                    [title]="item.LoadedAmt"
                >
                    {{ item.LoadedAmt | currency }}
                </td>
                <td
                    class="currency"
                    [title]="item.FeeCost"
                >
                    {{ item.FeeCost | currency }}
                </td>
                <td
                    class="currency"
                    [title]="item.PeriodTotal"
                >
                    {{ item.PeriodTotal | currency }}
                </td>
            </tr>
            <tr
                *ngIf="
                    rowGroupMetadata[item.groupIndex]?.indexEnd === rowIndex
                "
            >
                <!-- <td colspan="4" ></td> -->
                <td class="font-bold">Total:</td>
                <td class="font-bold">
                    {{ rowGroupMetadata[item.groupIndex]?.hours }}
                </td>
                <td class="currency font-bold">
                    {{
                        rowGroupMetadata[item.groupIndex]?.unloaded
                            | currency
                    }}
                </td>
                <td class="currency font-bold">
                    {{
                        rowGroupMetadata[item.groupIndex]?.loaded | currency
                    }}
                </td>
                <td class="currency font-bold">
                    {{ rowGroupMetadata[item.groupIndex]?.fee | currency }}
                </td>
                <td class="currency font-bold">
                    {{
                        rowGroupMetadata[item.groupIndex]?.total | currency
                    }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
